export default "__VITE_ASSET__BKDF7ne5__"